import React, { useEffect } from 'react';
import {Container, Sponsor, SponsorGrid } from './styles';

import Sponsors from '../Sponsors';
import { Apoio, ApoioGrid } from '../Sponsors/styles';
import { theme } from '../../config';





const FooterLayout: React.FC = ({ children }) => {

  return (

<Container>

<div style={{ display: 'flex', flexDirection:'column', alignItems: 'center', justifyContent: 'flex-start', minWidth: '150px', margin: '10px auto'}}>
<h2 style={{color: theme.colorReverse}}>Realização</h2>
<ApoioGrid size="G" >

  <Apoio background="/apoio/entidade.png"/>
</ApoioGrid>
</div>
<br/>
          <p style={{color: theme.colorReverse}}>
            Todos os direitos reservados - 2021
            <br />
          </p>
    
        </Container>
  );
};

export default FooterLayout;
